import { ASTGizmos } from '../ast-gizmos';
ASTGizmos.define();
export { ASTGizmos as CodeEditorGizmos };
//# sourceMappingURL=ast-gizmos.js.map